<template>
  <section class="testimonials" id="testimonials">
    <div class="container">
      <div class="section-header">
        <h4 class="brand-tag">{{ $t('testimonialsBrand') }}</h4>
        <h2>{{ $t('testimonialsHeadline') }}</h2>
        <p class="section-intro">{{ $t('testimonialsIntro') }}</p>
      </div>

      <Swiper
        :modules="modules"
        :slides-per-view="1"
        :space-between="30"
        :loop="true"
        :pagination="{ clickable: true, dynamicBullets: false }"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }"
        :breakpoints="{
          '768': { slidesPerView: 2 },
          '1024': { slidesPerView: 3 }
        }"
        class="testimonials-swiper"
      >
        <SwiperSlide>
          <div class="testimonial-card">
            <div class="quote-icon">“</div>
            <p class="testimonial-text">{{ $t('testimonial_1_text') }}</p>
            <div class="client-info">
              <div class="client-details">
                <strong>{{ $t('testimonial_1_name') }}</strong>
                <span>{{ $t('testimonial_1_role') }}</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="testimonial-card">
            <div class="quote-icon">“</div>
            <p class="testimonial-text">{{ $t('testimonial_2_text') }}</p>
            <div class="client-info">
              <div class="client-details">
                <strong>{{ $t('testimonial_2_name') }}</strong>
                <span>{{ $t('testimonial_2_role') }}</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="testimonial-card">
            <div class="quote-icon">“</div>
            <p class="testimonial-text">{{ $t('testimonial_3_text') }}</p>
            <div class="client-info">
              <div class="client-details">
                <strong>{{ $t('testimonial_3_name') }}</strong>
                <span>{{ $t('testimonial_3_role') }}</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="testimonial-card">
            <div class="quote-icon">“</div>
            <p class="testimonial-text">{{ $t('testimonial_4_text') }}</p>
            <div class="client-info">
              <div class="client-details">
                <strong>{{ $t('testimonial_4_name') }}</strong>
                <span>{{ $t('testimonial_4_role') }}</span>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="testimonial-card">
            <div class="quote-icon">“</div>
            <p class="testimonial-text">{{ $t('testimonial_5_text') }}</p>
            <div class="client-info">
              <div class="client-details">
                <strong>{{ $t('testimonial_5_name') }}</strong>
                <span>{{ $t('testimonial_5_role') }}</span>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

export default {
  name: 'TestimonialsSection',
  components: { Swiper, SwiperSlide },
  setup () {
    return {
      modules: [Pagination, Autoplay]
    }
  }
}
</script>

<style scoped>
.testimonials {
  background-color: #ffffff;
  padding: 100px 0;
  margin-bottom: 0;
  overflow: hidden;
}

.testimonials-swiper {
  padding: 40px 10px 80px;
}

.swiper-slide {
  height: auto !important;
  display: flex;
}

.testimonial-card {
  background: #F7F9FC;
  padding: 50px 40px 40px;
  border-radius: 24px;
  position: relative;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.03);
  width: 100%;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  background: #ffffff;
  box-shadow: 0 20px 40px rgba(6, 45, 69, 0.08);
  border-color: var(--secondary-color);
}

.quote-icon {
  font-size: 5rem;
  color: var(--secondary-color);
  opacity: 0.15;
  position: absolute;
  top: -10px;
  left: 20px;
  font-family: serif;
}

.testimonial-text {
  font-style: italic;
  font-size: 1.05rem;
  line-height: 1.7;
  color: var(--text-color);
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.client-info {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 20px;
  margin-top: auto;
}

.client-details strong {
  display: block;
  color: var(--primary-color);
  font-size: 1.1rem;
  font-weight: 700;
}

.client-details span {
  font-size: 0.85rem;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.testimonials {
  background-color: #ffffff;
  padding: 100px 0;
}

.testimonials-swiper {
  padding: 20px 0 60px;
}

.swiper-slide {
  height: auto !important;
  display: flex;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.brand-tag {
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.section-intro {
  max-width: 700px;
  margin: 0 auto;
  color: var(--text-color);
  opacity: 0.8;
}

.testimonial-card {
  background: #F7F9FC;
  padding: 40px;
  border-radius: 20px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin: 10px 5px;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(6, 45, 69, 0.05);
}

.quote-icon {
  font-family: var(--secondary-font);
  font-size: 4rem;
  color: var(--secondary-color);
  opacity: 0.3;
  line-height: 1;
  position: absolute;
  top: 10px;
  left: 20px;
}

.testimonial-text {
  font-style: italic;
  font-size: 1.05rem;
  line-height: 1.8;
  color: var(--text-color);
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.client-info {
  border-top: 1px solid rgba(0,0,0,0.05);
  padding-top: 20px;
}

.client-details strong {
  display: block;
  font-family: var(--secondary-font);
  color: var(--primary-color);
  font-size: 1.1rem;
}

.client-details span {
  font-size: 0.85rem;
  color: var(--secondary-color);
  font-weight: 600;
  text-transform: uppercase;
}

@media (max-width: 768px) {
  h2 {
    font-size: 2.5rem;
  }
  .testimonials { padding: 60px 0; }
  .testimonial-card {
    padding: 40px 30px 30px;
  }
}

</style>
